import { Injectable } from '@angular/core';
import * as UrlService from '../../shared/services/url.service';
import { Observable } from 'rxjs';
import { sharedConstants } from '../shared-constants';
import { UserSearchParam } from '../models/UserSearchParam';
import { User } from '../models/User';
import { userInfo } from '../models/userInfo';

@Injectable()
export class UserService {
  private controllerName: string = "User";

  constructor(
    private apiClient: UrlService.UrlService
  ) { }

  public getUserId(): Observable<userInfo> {
    return this.apiClient.get(
      sharedConstants.appName,
      this.controllerName,
      "Id",
      null,
      new UrlService.QueryOptions()
    );
  }

  public getUserInfo(): Observable<userInfo> {
    return this.apiClient.get(
      sharedConstants.appName,
      this.controllerName,
      "Info",
      null,
      new UrlService.QueryOptions()
    );
  }

  public GetName(): Observable<string> {
    return this.apiClient.get<string>(
      sharedConstants.appName,
      this.controllerName,
      "Name",
      null,
      null);
  }

  public GetDefaultFacility(): Observable<string> {
    return this.apiClient.get<string>(
      sharedConstants.appName,
      this.controllerName,
      "DefaultFacility",
      null,
      null);
  }

  public getUser(searchParams: UserSearchParam): Observable<User[]> {
    const query = new UrlService.OdataQuery();
    let searchFilterGroup = [] as UrlService.IOdataFilter[];

    if (searchParams.usersearch) {
      searchFilterGroup.push(
        new UrlService.OdataFilterSubstringOf(
          new UrlService.OdataFieldToLower(new UrlService.OdataFieldName("FirstName")),
          new UrlService.OdataFieldToLower(new UrlService.OdataFieldString(searchParams.usersearch))
        )
      );
      searchFilterGroup.push(
        new UrlService.OdataFilterSubstringOf(
          new UrlService.OdataFieldToLower(new UrlService.OdataFieldName("LastName")),
          new UrlService.OdataFieldToLower(new UrlService.OdataFieldString(searchParams.usersearch))
        )
      );
      searchFilterGroup.push(
        new UrlService.OdataFilterSubstringOf(
          new UrlService.OdataFieldToLower(new UrlService.OdataFieldName("Email")),
          new UrlService.OdataFieldToLower(new UrlService.OdataFieldString(searchParams.usersearch))
        )
      );
    }

    if (searchFilterGroup.length > 1) {
      const tempFilterGroup = [] as UrlService.IOdataFilter[];
      tempFilterGroup.push(
        new UrlService.OdataFilterGroup(
          searchFilterGroup,
          UrlService.OdataFilterGroupType.Or
        )
      );
      searchFilterGroup = tempFilterGroup;
    }

    if (searchFilterGroup.length > 0) {
      const tempFilterGroup = [] as UrlService.IOdataFilter[];
      tempFilterGroup.push(
        new UrlService.OdataFilterGroup(
          [
            searchFilterGroup[0],
          ],
          UrlService.OdataFilterGroupType.And
        )
      );
      query.setFilter(tempFilterGroup[0]);
    } else if (searchFilterGroup.length > 0) {
      query.setFilter(searchFilterGroup[0]);
    }

    return this.apiClient.get(sharedConstants.appName, this.controllerName, 'GetUsers', null,
      new UrlService.QueryOptions()
        .setOdataQuery(
          query
        )
    );

  }

}
